import {
  get, post, get1, post1,
} from '@/utils/request/mAxios';
import APIs from './index';
import { camleToSnake } from '@/utils/common';
import { disabledSnakeFields } from '@/utils/const';
import {
  CreateLabelData, DeleteLableData, PluginFuncLib, PluginDiffSubmitList,
} from '../type/configServerType';
import type { TransPluginItemContent } from '../type/configServerType';

interface EnvList{
  serviceId: string;
}
export function getEnvironmentList(params: EnvList) {
  return get(APIs.getEnvironmentList, params);
}

interface EnvDetail{
  serviceId: string;
  environmentId: string;
}
export function getEnvironmentDetail(params: EnvDetail) {
  return get(APIs.getEnvironmentDetail, params);
}

interface RPCName{
  serviceId: string;
  environmentId: string;
  configId: string;
}
export function getRPCServiceName(params: RPCName) {
  return get(APIs.getRPCServerName, params);
}

interface IdlInfo{
  serviceId: string;
  branch: string;
}
export function getBranchIDLInfo(params: IdlInfo) {
  return get(APIs.getBranchIDLInfo, params);
}

interface IdlInfoRequest{
  serviceId: string;
  environmentId: string | undefined;
  configId: string | undefined;
  config: any;
}
export function updateIDLInfo(data: IdlInfoRequest) {
  return post(APIs.updateIDLInfo, data);
}

interface InterfaceList{
  serviceId: string;
  environmentId: string;
  keyword?: string;
  auditId?: string;
  page?: number;
  pageSize?: number;
}
export function getInterfaceList(params: InterfaceList) {
  return get(APIs.getInterfaceList, params);
}

interface InterfaceDetail{
  serviceId: string;
  environmentId: string;
  configId: string;
}
export function getInterfaceDetail(data: InterfaceDetail) {
  const origin = camleToSnake(data);
  return get1(APIs.getInterfaceDetail, origin);
}

interface LastFullReleaseReq {
  serviceId: number;
  configId: number;
}
interface LastFullReleaseRes {
  releaseId: number; // 发布ID
  remark: string; // 发布备注
  releaseTime: string; // 发布时间
  value: string; // 发布内容
}
export function getLastFullRelease(data: LastFullReleaseReq) {
  return get<LastFullReleaseRes>(APIs.getLastFullRelease, data);
}

export function getNewInterfaceDetail(data: InterfaceDetail) {
  const origin = camleToSnake(data);
  return get1(APIs.getNewInterfaceDetail, origin);
}

interface InterfaceMigrateReq {
  serviceId: number;
  configId: number;
  dstServiceId: number;
}
// 接口跨服务迁移
export function interfaceMigrate(data: InterfaceMigrateReq) {
  return post(APIs.interfaceMigrate, data);
}

interface CreateInterface{
  serviceId: string;
  environmentId: string;
  path: string;
  method: string;
  rpcMethod: string;
  title: string;
}
export function createInterface(data: CreateInterface) {
  return post(APIs.createInterface, data);
}

interface UpdateInterface{
  serviceId: string;
  environmentId: string;
  configId: string;
  path: string;
  method: string;
  apiConfig?: string;
  routeConfig?: any;
}
export function updateInterface(data: UpdateInterface) {
  const origin = camleToSnake(data, disabledSnakeFields);
  return post1(APIs.updateInterface, origin);
}

export function updateNewInterface(data: any) {
  const origin = camleToSnake(data);
  return post1(APIs.updateInterfaceNew, origin);
}

interface OfflineParam{
  serviceId: string;
  environmentId: string;
  configId: string;
}
interface OfflineRes {
  activePublish: boolean;
  configId: number;
}
export function offlineInterface(data: OfflineParam) {
  return post<OfflineRes>(APIs.offlineInterface, data);
}
export function onlineInterface(data: OfflineParam) {
  return post<OfflineRes>(APIs.onlineInterface, data);
}
export function deleteInterface(data: OfflineParam) {
  return post(APIs.deleteInterface, data);
}

export function revokeAudit(data: DiffParam) {
  return post(APIs.revokeAudit, data);
}

interface DiffParam{
  serviceId: string;
  auditId?: string;
}

export function getInterfaceDiffInfo(param: DiffParam) {
  const origin = camleToSnake(param);
  return get1(APIs.getInterfaceDiffInfo, origin);
}

interface ReleaseData{
  configList: number[];
  serviceId: string;
  auditId?: string;
  environmentId: string;
  description: string;
  pluginConfigList: PluginDiffSubmitList[];
}
export function releaseInterface(data: ReleaseData) {
  return post(APIs.release, data);
}

interface ServiceParam{
  serviceId?: string;
  teamId?: string;
}
export function getServiceInfo(param: ServiceParam) {
  return get(APIs.getServiceInfo, param);
}

export function transferCodeModel(data: any) {
  const origin = camleToSnake(data);
  return post1(APIs.transferCodeModel, origin);
}

export function transferFormModel(data: any) {
  const origin = camleToSnake(data);
  return post1(APIs.transferFormModel, origin);
}

export function updateInterfaceLabel(data: CreateLabelData) {
  return post(APIs.updateInterfaceLabel, data);
}

export function deleteInterfaceLable(data: DeleteLableData) {
  return post(APIs.deleteInterfaceLable, data);
}

export function getCustomerPlugin() {
  return get(APIs.getCustomerPlugin);
}

// export function getInterfaceLabel(param: GetLableQuery) {
//   return post(APIs.getInterfaceLabel, param);
// }

interface PluginQueryParams {
  teamId: string;
  serviceId: string;
  environmentId: string;
  pluginName?: string;
  page?: number;
  pageSize?: number;
}

interface PluginReturnParams {
  pluginList: TransPluginItemContent[];
}

/**
 * 获取所有自定义函数插件的content相关信息
 */
export function getPlugins(param: PluginQueryParams) {
  return get<PluginReturnParams>(APIs.getPlugins, param);
}
interface PluginModelReq {
  label: string; // 服务标示： 自定义插件： custom_plugin
  version?: string;
}

interface PluginModelRes {
  content: string;
}

/**
 * 获取自定义函数插件的content模版
 */
export function getPluginModel(param: PluginModelReq) {
  return get<PluginModelRes>(APIs.getPluginModel, param);
}

interface PluginDebugQueryParams {
  pluginContent: string;
  requestParams?: string[];
  resultParams?: string[];
}

interface PluginDebugReturnParams {
  result: string[];
}

/**
 * 自定义函数插件校验
 */
export function pluginDebugger(param: PluginDebugQueryParams) {
  return post<PluginDebugReturnParams>(APIs.pluginDebugger, param);
}

interface FuncPluginDebugQueryParams {
  content: string; // 函数表达式内容
  param: {
    src: string;
    dataType: string;
  };
}

interface FuncPluginDebugReturnParams {
  result: {
    dst: string;
    dataType: string;
  };
}

/**
 * 常用函数插件校验
 */
export function funcPluginDebugger(param: FuncPluginDebugQueryParams) {
  return post<FuncPluginDebugReturnParams>(APIs.funcPluginDebugger, param);
}

interface FuncPluginLibReturnParams {
  paramsFunctionList: PluginFuncLib[];
}

/**
 * 获取常用函数库
 */
export function getFuncPluginLib() {
  return get<FuncPluginLibReturnParams>(APIs.getFuncPluginLib);
}
